function addEventListener<EventType = Event>(
  target: EventTarget,
  event: string,
  callback: (evt: EventType) => void,
  options?: boolean | AddEventListenerOptions
) {
  target.addEventListener(event, callback as unknown as EventListener, options);
}

export default addEventListener;
